        <aside 
          [class.sidebar-open]="isOpen"
          [class.sidebar-collapsed]="!isOpen"
          class="bg-slate-100 border-r border-border transition-all duration-300 ease-in-out overflow-hidden h-full flex flex-col"
        >
  <!-- Menu Items -->
  <nav class="flex-1 overflow-y-auto">
    <ul class="space-y-2 px-3 pt-6">
      <li *ngFor="let item of displayMenuItems">
        <!-- Parent Menu Item -->
        <div>
          <a
            *ngIf="!hasChildren(item) && item.route"
            [routerLink]="item.route"
            [class.bg-primary]="isMenuItemActive(item)"
            [class.text-white]="isMenuItemActive(item)"
            [class.text-primary]="!isMenuItemActive(item)"
            [class.justify-center]="!isOpen"
            [class.menu-item-hover]="!isMenuItemActive(item)"
            [class.menu-item-active-hover]="isMenuItemActive(item)"
            class="group flex items-center gap-4 px-4 h-12 rounded-lg text-base font-medium hover:text-primary transition-colors cursor-pointer"
            (click)="closeSidebarOnMobile()"
            [title]="!isOpen ? item.label : ''"
          >
            <img 
              [src]="item.iconPath" 
              [alt]="item.label + ' icon'"
              class="w-6 h-6 flex-shrink-0 object-contain"
            />
            <span *ngIf="isOpen" class="truncate flex-1">{{ item.label }}</span>
          </a>
          
          <div
            *ngIf="hasChildren(item)"
            [class.bg-primary]="isMenuItemActive(item)"
            [class.text-white]="isMenuItemActive(item)"
            [class.text-primary]="!isMenuItemActive(item)"
            [class.justify-center]="!isOpen"
            [class.menu-item-hover]="!isMenuItemActive(item)"
            [class.menu-item-active-hover]="isMenuItemActive(item)"
            class="group flex items-center gap-4 px-4 h-12 rounded-lg text-base font-semibold hover:text-primary transition-colors cursor-pointer menu-level-1"
            [class.menu-level-1-expanded]="isExpanded(item)"
            (click)="onParentClick(item, $event)"
            [title]="!isOpen ? item.label : ''"
          >
            <img 
              [src]="item.iconPath" 
              [alt]="item.label + ' icon'"
              class="w-6 h-6 flex-shrink-0 object-contain"
            />
            <span *ngIf="isOpen" class="truncate flex-1">{{ item.label }}</span>
            
            <!-- Dropdown Icon for items with children -->
            <fa-icon 
              *ngIf="isOpen && hasChildren(item)"
              [icon]="isExpanded(item) ? chevronDown : chevronRight"
              [class.text-white]="isMenuItemActive(item)"
              [class.text-primary]="!isMenuItemActive(item)"
              class="w-4 h-4 flex-shrink-0 transition-transform transition-colors"
            ></fa-icon>
          </div>

          <!-- Children Menu Items (level 2: sections; level 3: links) -->
          <ul 
            *ngIf="isOpen && hasChildren(item) && isExpanded(item)"
            class="menu-level-2-container ml-3 mt-2 mb-3 mr-2 space-y-1"
          >
            <li *ngFor="let child of item.children">
              <!-- Child has nested sub-items (e.g. Batch Admin, Charges, Submit) -->
              <ng-container *ngIf="hasSubChildren(child)">
                <div
                  (click)="toggleSubExpand(item, child, $event)"
                  [class.bg-primary]="isChildActive(child)"
                  [class.text-white]="isChildActive(child)"
                  [class.text-primary]="!isChildActive(child)"
                  [class.menu-item-hover]="!isChildActive(child)"
                  [class.menu-item-active-hover]="isChildActive(child)"
                  class="group flex items-center gap-3 px-3 h-10 rounded-md text-sm font-medium hover:text-primary transition-colors cursor-pointer menu-level-2"
                >
                  <span class="truncate flex-1">{{ child.label }}</span>
                  <fa-icon
                    *ngIf="isOpen"
                    [icon]="isSubExpanded(item, child) ? chevronDown : chevronRight"
                    [class.text-white]="isChildActive(child)"
                    [class.text-primary]="!isChildActive(child)"
                    class="w-3.5 h-3.5 flex-shrink-0"
                  ></fa-icon>
                </div>
                <ul
                  *ngIf="isSubExpanded(item, child)"
                  class="menu-level-3-container ml-2 mt-1.5 mb-2 space-y-0.5"
                >
                  <li *ngFor="let grandchild of child.children">
                    <!-- Grandchild has nested sub-items (e.g. Diagnosis Procedure) -->
                    <ng-container *ngIf="hasSubSubChildren(grandchild)">
                      <div
                        (click)="toggleSubSubExpand(item, child, grandchild, $event)"
                        [class.bg-primary]="isGrandchildWithChildrenActive(grandchild)"
                        [class.text-white]="isGrandchildWithChildrenActive(grandchild)"
                        [class.text-primary]="!isGrandchildWithChildrenActive(grandchild)"
                        [class.menu-item-hover]="!isGrandchildWithChildrenActive(grandchild)"
                        [class.menu-item-active-hover]="isGrandchildWithChildrenActive(grandchild)"
                        class="group flex items-center gap-2 px-2.5 h-9 rounded text-xs font-medium hover:text-primary transition-colors cursor-pointer menu-level-3"
                      >
                        <span class="truncate flex-1">{{ grandchild.label }}</span>
                        <fa-icon
                          [icon]="isSubSubExpanded(item, child, grandchild) ? chevronDown : chevronRight"
                          [class.text-white]="isGrandchildWithChildrenActive(grandchild)"
                          [class.text-primary]="!isGrandchildWithChildrenActive(grandchild)"
                          class="w-3 h-3 flex-shrink-0"
                        ></fa-icon>
                      </div>
                      <ul
                        *ngIf="isSubSubExpanded(item, child, grandchild)"
                        class="menu-level-4-container ml-2 mt-1 space-y-0.5"
                      >
                        <li *ngFor="let greatGrandchild of grandchild.children">
                          <a
                            [routerLink]="greatGrandchild.route"
                            [class.bg-primary]="isGreatGrandchildActive(greatGrandchild)"
                            [class.text-white]="isGreatGrandchildActive(greatGrandchild)"
                            [class.text-primary]="!isGreatGrandchildActive(greatGrandchild)"
                            [class.menu-item-hover]="!isGreatGrandchildActive(greatGrandchild)"
                            [class.menu-item-active-hover]="isGreatGrandchildActive(greatGrandchild)"
                            class="group flex items-center gap-2 px-2 h-8 rounded text-xs font-normal hover:text-primary transition-colors menu-level-4"
                            (click)="closeSidebarOnMobile()"
                          >
                            <span class="truncate">{{ greatGrandchild.label }}</span>
                          </a>
                        </li>
                      </ul>
                    </ng-container>
                    <!-- Grandchild is a direct link -->
                    <a
                      *ngIf="!hasSubSubChildren(grandchild) && grandchild.route"
                      [routerLink]="grandchild.route"
                      [class.bg-primary]="isGrandchildActive(grandchild)"
                      [class.text-white]="isGrandchildActive(grandchild)"
                      [class.text-primary]="!isGrandchildActive(grandchild)"
                      [class.menu-item-hover]="!isGrandchildActive(grandchild)"
                      [class.menu-item-active-hover]="isGrandchildActive(grandchild)"
                      class="group flex items-center gap-2 px-2.5 h-9 rounded text-xs font-medium hover:text-primary transition-colors menu-level-3"
                      (click)="closeSidebarOnMobile()"
                    >
                      <img 
                        *ngIf="grandchild.iconPath"
                        [src]="grandchild.iconPath" 
                        [alt]="grandchild.label + ' icon'"
                        class="w-3.5 h-3.5 flex-shrink-0 object-contain"
                      />
                      <span class="truncate">{{ grandchild.label }}</span>
                    </a>
                  </li>
                </ul>
              </ng-container>
              <!-- Child is a direct link (no nested children) -->
              <a
                *ngIf="!hasSubChildren(child) && child.route"
                [routerLink]="child.route"
                [class.bg-primary]="isChildActive(child)"
                [class.text-white]="isChildActive(child)"
                [class.text-primary]="!isChildActive(child)"
                [class.menu-item-hover]="!isChildActive(child)"
                [class.menu-item-active-hover]="isChildActive(child)"
                class="group flex items-center gap-3 px-3 h-10 rounded-md text-sm font-medium hover:text-primary transition-colors menu-level-2"
                (click)="closeSidebarOnMobile()"
              >
                <img 
                  *ngIf="child.iconPath"
                  [src]="child.iconPath" 
                  [alt]="child.label + ' icon'"
                  class="w-4 h-4 flex-shrink-0 object-contain"
                />
                <span class="truncate">{{ child.label }}</span>
              </a>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </nav>
</aside>
